import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTablesModule } from 'angular-datatables';
import { SharedModule } from '../shared.module';
import { ImportacionFacturasMasivasComponent } from './importacion-facturas-masivas/importacion-facturas-masivas.component';
import { EmpresaFormComponent } from './empresa-form/empresa-form.component';
import { ResolucionComponent } from './empresa-form/resolucion/resolucion.component';
import { ResolucionFormComponent } from './empresa-form/resolucion/resolucion-form/resolucion-form.component';
import { SoftwareFormComponent } from './empresa-form/software/software-form/software-form.component';
import { SoftwareComponent } from './empresa-form/software/software.component';

@NgModule({
	declarations: [
		ImportacionFacturasMasivasComponent,
		EmpresaFormComponent,
		ResolucionComponent,
		ResolucionFormComponent,
		SoftwareFormComponent,
		SoftwareComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		BrowserAnimationsModule,
		ReactiveFormsModule,
		DataTablesModule,
		SharedModule,
	],
	providers: [
	]
})
export class ViewsModule { }
